import { fetchData } from 'services/fetchData';

import { authStore } from 'stores';

/**
 * Send a request to the API to update a Remediation Task.
 * @param {Object} updatedRemediationTask Remediation Task to update.
 * @returns the newly updated Remediation Task.
 */
export const updateRemediationTask = async (updatedRemediationTask) => {
    const { jwtToken } = authStore.getState('passwordSession').value.sessionDetails;

    const httpOptions = {
        method: 'PATCH',
        headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
        },
        withCredentials: true,
        body: JSON.stringify(updatedRemediationTask)
    };

    const requestPath = `/remediationTask`;
    const { data } = await fetchData(requestPath, httpOptions);
    return data;
};
